import { useHistory } from 'react-router';
import { useOverlayContext } from 'seagull';
import { routes } from "../../../constants";
import { useStoreActions } from "../../../store/store-context";
import { PracticeManagement } from "../../../types/api.model";
import APIKeyModal from "../APIKeyModal/APIKeyModal";
import { CardHandler } from "../APIKeyPM/APIKeyPM.utils";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import KarbonLogo from "./KarbonLogo";
import { jsx as _jsx } from "react/jsx-runtime";
const KarbonCard = _ref => {
  let {
    integration
  } = _ref;
  const history = useHistory();
  const overlayContext = useOverlayContext();
  const {
    api,
    fetchIntegrations
  } = useStoreActions();
  const ui = {
    goToPage: page => history.push(page),
    requestApiKey: apiKeyListener => overlayContext.showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(APIKeyModal, {
          pmName: PracticeManagement.Karbon,
          dismissModal: dismissModal,
          apiKeyListener: apiKeyListener
        });
      }
    }),
    refetchIntegrations: async () => fetchIntegrations()
  };
  const server = {
    saveApiKey: async apiKey => api.karbon.setAPIKey(apiKey)
  };
  const karbonCardHandler = new CardHandler(ui, integration, server);
  return /*#__PURE__*/_jsx(IntegrationCard, {
    testId: "karbon-card",
    title: "Karbon",
    subTitle: "Connect your account to boost teamwork and streamline processes",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      testId: "karbon-card-connect",
      onClick: () => karbonCardHandler.handleClick(routes.karbonSetup),
      children: karbonCardHandler.getActionText()
    }),
    icon: /*#__PURE__*/_jsx(KarbonLogo, {})
  });
};
export default KarbonCard;